import productionStoreConfig from './productionStoreConfig';
import developmentStoreConfig from './developmentStoreConfig';
import { createBrowserHistory} from 'history'
import queryString from 'query-string'
import _ from 'lodash'

export const history = createBrowserHistory({
  forceRefresh:false
});

history.location = _.assign(history.location,{ search: queryString.parse(history.location.search)})

history.listen((location,action) => {
  location.search = queryString.parse(location.search) 
})


export default function configureStore(initialState){
  if( process.env.ENV === 'production'){
    return productionStoreConfig(initialState, history)
  }else {
    return developmentStoreConfig(initialState, history);
  }
}